<template lang="pug">
  .changelog
    section
      .max-width
        .breadcrumbs(v-if="isApp")
          ul
            li
              router-link.primary-link(:to="{ name: isAdmin ? 'AdminDashboard' : 'PublicDashboard'}") Dashboard
            li
              span \
            li
              span Changelogs

    section
      .max-width
        header.changelog-header
          .tabs
            .row.apart
              .col
                .tab.active
                  h2 Changelogs

        ChangelogPreview(v-for="changelog in changelogs", :changelog="changelog", :key="changelog._id")

</template>

<script>

import { mapState } from 'vuex'
import ChangelogPreview from '@/components/ChangelogPreview'

export default {
  name: 'PublicChangelog',
  components: {
    ChangelogPreview
  },
  data () {
    return {
    }
  },
  beforeMount () {
    console.log('public changeloga')
    this.getChangelogs()
  },
  computed: {
    ...mapState({
      company: state => state.company,
      changelogs: state => state.changelogs.list
    }),
    isAdmin () {
      return this.$route.matched[0].meta.member
    },
    isApp () {
      //console.log(this.$route)
      return !(this.$route.meta && this.$route.meta.widget)
    }
  },
  methods: {
    getChangelogs () {
      this.$store.dispatch('changelogs/getChangelogs')
    }
  },
  watch: {
  }
}

</script>

<style lang="stylus" scoped>
</style>
